import { render, staticRenderFns } from "./ContributorsFeed.vue?vue&type=template&id=ab860544&scoped=true&"
import script from "./ContributorsFeed.vue?vue&type=script&lang=js&"
export * from "./ContributorsFeed.vue?vue&type=script&lang=js&"
import style0 from "./ContributorsFeed.vue?vue&type=style&index=0&id=ab860544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab860544",
  null
  
)

export default component.exports